import { industries } from '~/data/siteData'
import { IndustriesSection } from '~/components/Sections'

export default function IndustriesPage() {
  return (
    <main>
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">Industries We Serve</span>
          <h1 className="page-hero-title">Powering Print Across Sectors</h1>
          <p className="page-hero-desc">
            Our VICTORY machines and VisionJet inks serve diverse applications —
            from signage and advertising to textile printing and packaging.
          </p>
        </div>
      </section>
      <IndustriesSection items={industries} />
    </main>
  )
}
